<template>
    <rkm-overlay>
        <rkm-layout-body title="Alteração exame finalizado">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave()"
                />
            </rkm-layout-content>

        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/exame-imagem/alteracao-exame-finalizado/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'exame-imagem-alteracao-exame-finalizado-create' })
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>